module.exports = "<xo-generic-error cancel-url=\"{{cancelUrl}}\"></xo-generic-error>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-generic-error/template.html
// module id = ./pages/xo-error/xo-generic-error/template.html
// module chunks = 1